export const AUTH0_TOKEN_PENDING = 'AUTH0_TOKEN_PENDING'
export const AUTH0_TOKEN_SUCCESS = 'AUTH0_TOKEN_SUCCESS'
export const AUTH0_TOKEN_FAILURE = 'AUTH0_TOKEN_FAILURE'
export const AUTH0_FF_PENDING = 'AUTH0_FF_PENDING'
export const AUTH0_FF_DONE = 'AUTH0_FF_DONE'
